<template>
<div class="chapter">
<div class="inner_page">
<div id="fm7">
<p><span class="small">CODE NAME: GRAND GUIGNOL</span> is based on a fantastic, little-known scheme of the Nazis during World War II just before D-Day — a scheme that has been “forgotten” in the dramatic events that followed the invasion, but a scheme that, had it been successful, might drastically have altered those events.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Code_Name_Grand_Guignol.vue?8cfa7e0e